import React, { useEffect, useState } from 'react';
import { useAppState } from "../application/AppState";
import { DataGrid } from '@mui/x-data-grid';
import FileXForm from "./FileForms/FileXForm";
import { Typography } from '@material-ui/core';
import useTranslation from "../application/translation";
import { formatDateAccordingToLanguage } from "../application/utils";

function addPrefix(claimEvent) {
    return "SK-" + claimEvent.claim_CreDate.substring(2) + "-" + claimEvent.claimEvent_id;
}

function removePrefix(claimId) {
    return claimId.substring(12);
}

const ClaimEvents = () => {
    const [{ claimEvents, language }] = useAppState();
    const [claimRows, setClaimRows] = useState([]);
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [selectedEventType, setSelectedEventType] = useState(null);
    const [selectionModel, setSelectionModel] = useState([]);
    const [selectionEventModel, setSelectionEventModel] = useState([]);
    const [columnsClaimEvent, setColumnsClaimEvent] = useState([]);
    const [columnsClaim, setColumnsClaim] = useState([]);
    const translation = useTranslation();

    useEffect(() => {
        setColumnsClaimEvent([
            { field: 'id', headerName: translation.update_label_claimcase, width: 170 },
            { field: 'claimType_Name', headerName: translation.update_label_claimetype, width: 170 },
            { field: 'claim_StartDate', headerName: translation.update_label_reported, width: 170 },
        ]);

        setColumnsClaim([
            { field: 'id', headerName: 'ID', width: 70 },
            { field: 'claim_Startdate', headerName: translation.update_label_reported, width: 170 },
            { field: 'claimStatus_Name', headerName: translation.update_label_status, width: 270 },
            { field: 'cardLoanName', headerName: translation.update_label_cardloan, width: 170 },
        ]);
    }, [translation]);

    const renderClaimEventRows = () =>
        claimEvents.map(event => ({
            id: addPrefix(event),
            claimType_Name: event.claimType_Name,
            claim_StartDate: formatDateAccordingToLanguage(event.claim_StartDate, language),
        }));

    const currentlySelectedEvent = selection => {
        if (!selection.length) return;
        const selId = parseInt(removePrefix(selection[0]), 10);
        const ev = claimEvents.find(e => e.claimEvent_id === selId);
        if (!ev) return;
        const rows = ev.claims.map(claim => ({
            id: claim.claim_Id,
            claim_Startdate: formatDateAccordingToLanguage(claim.claim_Startdate, language),
            claimStatus_Name: claim.claimStatus_Name,
            cardLoanName: claim.cardLoanName,
        }));
        setSelectedEvent(ev);
        setSelectedEventType(null);
        setClaimRows(rows);
    };

    const currentlySelectedClaim = selection => {
        if (!selection.length || !selectedEvent) return;
        const claim = selectedEvent.claims.find(c => c.claim_Id === selection[0]);
        if (claim) setSelectedEventType(claim.claimType_Id);
    };

    return (
        <div style={{ height: "100%" }}>
            <Typography variant="h6" component="h1">
                {translation.header}
            </Typography>
            <Typography variant="body2" component="p">
                {translation.text}
            </Typography>

            <br />

            {/* Claim‐Events grid */}
            <div
                role="region"
                aria-label={translation.update_label_claimcase}
                tabIndex={0}
                style={{ height: 250, width: '90%' }}
            >
                {claimEvents.length > 0 ? (
                    <DataGrid
                        rows={renderClaimEventRows()}
                        columns={columnsClaimEvent}
                        hideFooter            
                        tabIndex={0}            
                        aria-label={translation.update_label_claimcases}
                        onSelectionModelChange={newSel => {
                            setSelectionModel(newSel);
                            currentlySelectedEvent(newSel);
                        }}
                        selectionModel={selectionModel}
                        slotProps={{          
                            virtualScroller: { tabIndex: 0 }
                        }}
                    />
                ) : (
                    <Typography variant="body2" role="status">
                            Det finns inga skador att visa
                    </Typography>
                )}
            </div>

            <br />

            {/* Selected‐Event details grid */}
            <div
                role="region"
                aria-label={translation.update_label_claims}
                tabIndex={0}
                style={{ height: 200, width: '90%', position: 'relative' }}
            >
                {selectedEvent && (
                    <Typography variant="subtitle1" aria-live="polite">
                        {translation.update_claimlabel} {addPrefix(selectedEvent)}
                    </Typography>
                )}
                {claimRows.length > 0 && (
                    <DataGrid
                        rows={claimRows}
                        columns={columnsClaim}
                        hideFooter
                        autoHeight
                        tabIndex={0}
                        aria-label={translation.update_label_claims}
                        onSelectionModelChange={newSel => {
                            setSelectionEventModel(newSel);
                            currentlySelectedClaim(newSel);
                        }}
                        selectionModel={selectionEventModel}
                        slotProps={{
                            virtualScroller: { tabIndex: 0 }
                        }}
                    />
                )}
            </div>

            <br />

            {(selectedEventType === 1 || selectedEventType === 2 || selectedEventType === 5) && (
                <FileXForm
                    selectedEventType={selectedEventType}
                    claimevent_Id={selectedEvent.claimEvent_id}
                />
            )}
        </div>
    );
};

export default ClaimEvents;
